// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Region from "common/src/Region.bs.js";
import * as Router from "common/src/Router.bs.js";
import * as LbUtils from "./LbUtils.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as LbRanked from "./LbRanked.bs.js";
import * as LbTopRow from "./LbTopRow.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as LbTypeSelect from "./LbTypeSelect.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as LbPlayerSearch from "./LbPlayerSearch.bs.js";

var topTiers = [
  "CHALLENGER",
  "GRANDMASTER",
  "MASTER"
];

function LbDuo(Props) {
  var region = Props.region;
  var data = Props.data;
  var router = Router.use(undefined);
  var region$1 = Belt_Option.flatMap(region, Region.fromName);
  Belt_Option.mapWithDefault(region$1, "global", Region.toApiName);
  var lu = data.date;
  var data$1 = data.entries;
  var lastUpdated = React.useMemo((function () {
          return new Date(lu);
        }), [lu]);
  var match = React.useState(function () {
        return false;
      });
  var usePatchStats = match[0];
  var renderElements = LbUtils.useRenderElements(undefined);
  var data$2 = React.useMemo((function () {
          return Belt_Array.slice(data$1, 0, renderElements);
        }), [
        data$1,
        renderElements
      ]);
  var regionLabel = region$1 !== undefined ? Region.toName3(region$1) : "global";
  var keyFn = React.useCallback((function (d) {
          return d.region + " " + d.playerName + " " + d.tag;
        }), []);
  var setRegion = React.useCallback((function (region) {
          return router.push(Route.toString({
                          TAG: /* Leaderboards */7,
                          _0: {
                            TAG: /* Duo */2,
                            _0: region
                          }
                        }), undefined, undefined);
        }), []);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(LbPlayerSearch.make, {}), React.createElement(LbTypeSelect.make, {
                  region: region$1,
                  typ: /* Duo */1
                }), React.createElement(ContentSection.make, {
                  className: "font-montserrat font-medium md:w-[920px]",
                  children: null,
                  noPadding: true
                }, React.createElement(LbTopRow.make, {
                      region: region$1,
                      lastUpdated: lastUpdated,
                      setRegion: setRegion
                    }), React.createElement("div", {
                      className: usePatchStats ? "lb-patch-stats" : "lb-season-stats"
                    }, React.createElement(StatsTable2.make, {
                          montserratHeader: true,
                          size: "lg",
                          cols: LbRanked.cols,
                          data: data$2,
                          context: undefined,
                          extraStickyHeader: React.createElement("div", {
                                className: "h-10 flex items-center justify-between pt-1 pr-6 text-center font-semibold"
                              }, React.createElement("div", {
                                    className: "pl-3 font-medium"
                                  }, "Top " + regionLabel + " double up players"), React.createElement(LbUtils.PatchStatsToggle.make, {
                                    usePatchStats: usePatchStats,
                                    setUsePatchStats: match[1]
                                  })),
                          keyFn: keyFn,
                          stickyColCount: 2,
                          top: "t48"
                        }))));
}

var cols = LbRanked.cols;

var make = LbDuo;

export {
  topTiers ,
  cols ,
  make ,
  
}
/* Route Not a pure module */
